// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
/*cookie*/
import VueCookies from "vue-cookies";
Vue.use(VueCookies);
/*http请求 */
import http from "./utils/api";
import { baseUrl, httpGet, httpPost, httpPostToken } from "./utils/httpService";

/* 引入element UI框架 */
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "element-ui/lib/theme-chalk/display.css";
import { Message } from "element-ui";
Vue.use(ElementUI);

//vant
import Button from "vant/lib/button";
import "vant/lib/button/style";
Vue.use(Button);
import Notify from "vant/lib/Notify";
import "vant/lib/Notify/style";
Vue.use(Notify);
import Dialog from "vant/lib/Dialog";
import "vant/lib/Dialog/style";
Vue.use(Dialog);
/*引本地阿里图标库 */
import "./assets/iconfont/iconfont.css";
import "./assets/xzhlIconfont/iconfont.css";

/*外联自定义样式 */
import "../src/assets/style/reset.css";
import "../src/assets/style/common.css";
// import "../src/assets/style/media.less";

/** 公共组件bus*/
let bus = new Vue();
Vue.prototype.bus = bus;

/**引入moment */
import moment from "moment";
Vue.filter("dateFormat", function(value, formatStr = "YYYY-MM-DD HH:mm:ss") {
  return moment(value).format(formatStr);
});
// Vue.prototype.$moment = moment;

/*挂载http请求*/
Vue.prototype.$http = http;
Vue.prototype.$http = http;
Vue.prototype.httpGet = httpGet;
Vue.prototype.httpPost = httpPost;
Vue.prototype.httpPostToken = httpPostToken;
Vue.prototype.baseUrl = baseUrl;

Vue.config.productionTip = false;
// 跳转后返回顶部
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
// const originalPush = router.prototype.push;
// router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err);
// };

//全局注册组件
import Head from "./components/common/Head.vue";
import Foot from "./components/common/Foot.vue";
Vue.component("headBar", Head);
Vue.component("footBar", Foot);
/**导航守卫 */
router.beforeEach(function(to, from, next) {
  let token = VueCookies.get("nursing_tokenWeb");
  let require = to.matched.some(function(item) {
    // 是否需要登录
    return item.meta.isLogin;
  });
  if (VueCookies.get("nursing_tokenWeb") && to.name == "login") {
    Message({
      showClose: true,
      message: "您已登录!",
      type: "warning"
    });
    next(from.path);
  } else {
    // 已登录就正常跳转，不做任何拦截
    next(); // 正常跳转到下一页
  }
  if (!token && require) {
    Message({
      showClose: true,
      message: "请登录，登录后可进入循证注册平台!",
      type: "warning"
    }); // 当未登录，且跳转的页面需要登录后才能操作时，进行路由拦截
    next("/login");
  } else {
    // 已登录就正常跳转，不做任何拦截
    next(); // 正常跳转到下一页
  }
});
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js